'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$002413 from "./presto.-Presto$$anon$13.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$002415 from "./presto.-Presto$$anon$15.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$00243 from "./presto.-Presto$$anon$3.js";
import * as $j_presto$002e$002dPresto$0024$0024anon$00245 from "./presto.-Presto$$anon$5.js";
import * as $j_presto$002etypes$0024$002dSingle$002dApp$002dUser$0024 from "./presto.types$-Single-App-User$.js";
var $p;
/** @constructor */
function $c_Lpresto_Presto$$anon$2() {
  this.bbo = null;
  this.bbg = null;
  this.bbh = false;
  this.bbp = null;
  this.bbq = false;
  this.bbt = null;
  this.bbm = null;
  this.bbn = false;
  this.bbi = null;
  this.bbj = false;
  this.bbk = null;
  this.bbl = false;
  this.bbr = false;
  this.bbs = false;
  this.bbo = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bbt = "SingleAppUser";
}
export { $c_Lpresto_Presto$$anon$2 as $c_Lpresto_Presto$$anon$2 };
$p = $c_Lpresto_Presto$$anon$2.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Presto$$anon$2;
/** @constructor */
function $h_Lpresto_Presto$$anon$2() {
}
export { $h_Lpresto_Presto$$anon$2 as $h_Lpresto_Presto$$anon$2 };
$h_Lpresto_Presto$$anon$2.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.bbo;
});
$p.L = (function() {
  if ((!this.bbh)) {
    this.bbg = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bbh = true;
  }
  return this.bbg;
});
$p.O = (function() {
  if ((!this.bbq)) {
    this.bbp = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bbq = true;
  }
  return this.bbp;
});
$p.E = (function() {
  return this.bbt;
});
$p.t = (function() {
  if ((!this.bbn)) {
    this.bbm = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("details", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("application", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("impersonatedBy", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bbn = true;
  }
  return this.bbm;
});
$p.M = (function() {
  if ((!this.bbj)) {
    this.bbi = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dPresto$0024$0024anon$00243.$c_Lpresto_Presto$$anon$3(), ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dPresto$0024$0024anon$00245.$c_Lpresto_Presto$$anon$5(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$OptionDecoder(new $j_presto$002e$002dPresto$0024$0024anon$002413.$c_Lpresto_Presto$$anon$13())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.bbj = true;
  }
  return this.bbi;
});
$p.Q = (function() {
  if ((!this.bbl)) {
    this.bbk = new $j_presto$002e$002dPresto$0024$0024anon$002415.$c_Lpresto_Presto$$anon$15();
    this.bbl = true;
  }
  return this.bbk;
});
$p.w = (function() {
  if ((!this.bbs)) {
    this.bbr = false;
    this.bbs = true;
  }
  return this.bbr;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee95) => ((p) => \u03b4scrutinee95.adf(p)))($j_presto$002etypes$0024$002dSingle$002dApp$002dUser$0024.$m_Lpresto_types$SingleAppUser$())));
});
var $d_Lpresto_Presto$$anon$2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Presto$$anon$2, "presto.Presto$$anon$2", ({
  Nd: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_Presto$$anon$2 as $d_Lpresto_Presto$$anon$2 };
//# sourceMappingURL=presto.-Presto$$anon$2.js.map
